import { Component, Input } from "@angular/core";

export interface PublicViewAuRow {
  administrativeUnit: string;
  school: string;
  districtSpEdContact: string;
}

@Component({
  selector: "app-public-view-administrative-units-list",
  templateUrl: "./public-view-administrative-units-list.component.html",
  styleUrls: ["./public-view-administrative-units-list.component.scss"],
  standalone: false,
})
export class PublicViewAdministrativeUnitsListComponent {
  // Pre-resolved rows (names looked up by the parent, since AU/School names are school-year specific).
  @Input() rows: PublicViewAuRow[] = [];

  displayedColumns: string[] = ["administrativeUnit", "school", "districtSpEdContact"];
}
